import React, { useEffect, useState } from "react";
import {
  FiSearch,
  FiTrendingUp,
  FiTrendingDown,
  FiUserX,
  FiActivity,
} from "react-icons/fi";
import "../assets/css/UserActivityDetail.css";
import { useNavigate } from "react-router-dom";
import { searchUser } from "../Service/apiService";
let cachedStats = {
   totalSearchCount: 0,
    mostActive: 0,
    leastActive: 0,
    inactiveUsers: 0,
    trialUsers: 0,
    payingUsers: 0,
    expiringSoon: 0,
    highUsage: 0,
};
const hasValidStats = (stats) => {
  return Object.values(stats).some(value => value > 0);
};
export default function UserActivityDetails() {
  const navigate = useNavigate();
 const [stats, setStats] = useState(() => ({ ...cachedStats }));
  const [loading, setLoading] = useState(() => !hasValidStats(cachedStats));
 
    const formatNumber = (num) => {
    if (num === null || num === undefined) return "—";
    return Number(num).toLocaleString();
  };

  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const parsed = Date.parse(dateStr);
    return isNaN(parsed) ? null : new Date(parsed);
  };

 useEffect(() => {
     // Only fetch if we don't have valid cached data
     if (!hasValidStats(cachedStats)) {
       fetchUserStats();
     }
   }, []);

  const fetchUserStats = async () => {
    setLoading(true);
    try {
      const response = await searchUser("?userDeleted=false", { industry: "" });
      const users = Array.isArray(response?.result) ? response.result : [];

      const isNotInternal = (u) =>
        (u.companyType || "").toLowerCase() !== "internal";
      const nonInternalUsers = users.filter(isNotInternal);

      // 1. Total Search Count = sum of twelveMonthCount
      const totalSearchCount = nonInternalUsers.reduce(
        (sum, u) => sum + (u?.searchCounts?.twelveMonthCount || 0),
        0
      );

      // 2. Active users (non-internal + activeStatus === true)
      const activeUsers = nonInternalUsers.filter(
        (u) => u.activeStatus === true
      );

      // 3. Inactive users (non-internal + activeStatus === false)
      const inactiveUsers = nonInternalUsers.filter(
        (u) => u.activeStatus === false
      ).length;

      // 4. Most/Least Active = full list of active users (old dashboard sorts on click, doesn't pre-filter)
      const activeCount = activeUsers.length;

      const computed = {
        totalSearchCount,
        mostActive: activeCount,
        leastActive: activeCount,
        inactiveUsers,
      };
       setStats(computed);
    cachedStats = { ...computed };
    } catch (err) {
      console.error("Error fetching user activity stats:", err);
    }finally {
      setLoading(false);
    }
  };

  // Updated metrics with real values
    const metrics = [
    {
      id: "total-search-count",
      key: "totalSearchCount",
      label: "Total Search Count",
      value: formatNumber(stats.totalSearchCount),
      icon: FiSearch,    
      color: "rgb(5, 55, 99)",
    },
    {
      id: "most-active",
      key: "mostActiveUsers",
      label: "Most Active Users",
      value: formatNumber(stats.mostActive),
      icon: FiTrendingUp, 
      color: "rgb(5, 55, 99)",
    },
    {
      id: "least-active",
      key: "leastActiveUsers",
      label: "Least Active Users",
      value: formatNumber(stats.leastActive),
      icon: FiTrendingDown, 
      color: "rgb(5, 55, 99)",
    },
    {
      id: "inactive-users",
      key: "inactiveUsers",
      label: "Inactive Users",
      value: formatNumber(stats.inactiveUsers),
      icon: FiUserX,       
      color: "rgb(5, 55, 99)",
    },
  ];

  const goToTable = (key) => {
    navigate(`/dashboard/users/${key}`);
  };
    const NumberSkeleton = () => (
    <div className="number-skeleton">
      <div className="skeleton-loader"></div>
    </div>
  );


  return (
    <div className="user-activity-container">
  

      <div className="metrics-grid">
        {metrics.map(({ id, label, value, icon: Icon, color, key }) => (
          <div key={id} className="metric-card" onClick={() => goToTable(key)}>
            <div className="metric-icon" style={{ backgroundColor: color }}>
              <Icon size={18} />
            </div>
            
            <p className="metric-label">{label}</p>
            {loading ? (
              <NumberSkeleton />
            ) : (
              <p className="metric-value">{value}</p>
            )}
          
          </div>
        ))}
      </div>
    </div>
  );
}
